export const SHARED_NAMESPACE = "shared";
